//import React from 'react'
//import Nav from './navbar-hp';
//import { Outlet, Link, NavLink } from "react-router-dom";
//import { useState, useEffect } from "react"
import "98.css";

export default function IncorrectPass({onClose}) {

    // function handleKeyDown(e) {
    //     //console.log(e.key)
    //     if (e.key === 'Enter') {
    //         document.querySelector('.incorrect_password-buttons button').click();
    //     }
    // }

    return (
        <>

        <div className="window" data-name="Incorrect Password">

            <div className="title-bar">
                <div className="title-bar-text">Uh oh...</div>
            </div>

            <div className="window-body">
                <div id="incorrect_password">
                    <img src="/images/social_logos_cropped/msg_error-0.png" alt="error icon"/>
                    <p>The password you entered is incorrect.</p>
                </div>
                <div className="incorrect_password-buttons">
                    <button className="" onClick={onClose} tabIndex={0} type="submit" value="OK">OK</button>
                </div>
            </div>
            
        </div>

        </> 
    )
}